import { Button } from "../../Atoms/Button";
import { SubTitle } from "../../Atoms/SubTitle";
import { Title } from "../../Atoms/Title";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import { Card } from "../Trainings/Components/Card";
import { useTraining } from "./useTrainings";
import { useParams } from "react-router-dom";

export const Training = () => {
  const { navigate } = useTraining();
  const { videoId } = useParams<{ videoId: string }>();

  return (
    <LayoutTemplate>
      <div>
        <Button data-variant-text onClick={() => navigate(-1)}>
          <img src="/assets/svgs/icon-arrow-left-green.svg" alt="seta" />
          Voltar
        </Button>
      </div>
      <div className="lg:px-9 py-8">
        <div className="flex flex-col gap-4 mb-9">
          <p className="px-4 py-1 border border-solid border-[#E7EDEC] rounded-[100px] w-fit">
            Onboarding
          </p>
          <Title className="!mb-0">Processo de Vistoria Veicular</Title>
          <SubTitle className="text-[#2d2d2d]">
            Procedimentos, orientações e boas práticas para a realização de
            vistorias veiculares.
          </SubTitle>
          <div className="flex gap-4 pb-6">
            <div className="flex gap-3 items-center">
              <img src="/assets/svgs/icon-play-green.svg" alt="icone play" />
              <p>1 vídeo</p>
            </div>
            <div className="flex gap-3 items-center">
              <img
                src="/assets/svgs/icon-clock-green.svg"
                alt="icone  relogio"
              />
              <p>20 min</p>
            </div>
          </div>
        </div>
        <div>
          <Card className="flex-1 lg:max-w-[890px]">
            <p className="mb-3">Módulo Único</p>
            <h2 className="mb-6 text-xl font-extrabold">
              Processo de Vistoria Veicular
            </h2>
            <div className="relative w-full pt-[56.25%] bg-black rounded">
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded"
                src={`https://www.youtube.com/embed/f0vwi3h0MA0?si=F5kaoIb2grP1kFQK`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </Card>
        </div>
      </div>
    </LayoutTemplate>
  );
};
